export default {"src":"/_next/static/media/arrow.03744073.svg","height":24,"width":24};